
import React from 'react';

export const MoonIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    dark_mode
  </span>
);